import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AssessmentList from './List';
import AssessmentCreate from './Create';
import AssessmentDetail from './Detail';

const defaultFields = {
    Subject : { visible: false, label: '', required: false },
    Type: { visible: false, label: '', required: false },
    Description: { visible: false, label: '', required: false },
    TaskOrder: { visible: false, label: '', required: false },
    ProjectOrder: { visible: false, label: '', required: false },
    Amount: { visible: false, label: '', required: false },
    EffectContractPrice: { visible: false, label: '', required: false },
    Days: { visible: false, label: '', required: false },
    EffectContractCompletion: { visible: false, label: '', required: false }
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
    const fields = { ...defaultFields };

    var tempFields = placeholdersQA.FieldsPM.values.reduce((obj, fieldDesc) => ({ ...obj, [fieldDesc.field]: fieldDesc }), {});

    for (const [key, val] of Object.entries(tempFields)) {
        if (fields[key]) {
            fields[key].label = val.display;//val.isActive ? val.display : '';
            fields[key].visible = !!val.isActive;
        }
    }
    if(contract?.ispackaged === true){
        fields.Amount.visible = false;
    }

    if (placeholdersQA.TaskOrderOptionEnabled) {
        const taskOrderOptionEnabled = placeholdersQA.TaskOrderOptionEnabled?.values
            .find(phItem => phItem.field === 'TaskOrderOptionEnabled').isActive;

        if (taskOrderOptionEnabled) {
            const toTemplate = languageFile["CONTRACT.WF.COMPENSATION.FIELD.TASK_ORDER"];
    
            const to = toTemplate
                .replace("{TASK_ORDER}", (workflowsQA['38'] || {}).notificationName);
                
            fields.TaskOrder = { visible: true, label: to, required: false };
        }
    }

    if (placeholdersQA.ProjectOrderOptionEnabled) {
        const projectOrderOptionEnabled = placeholdersQA.ProjectOrderOptionEnabled?.values
            .find(phItem => phItem.field === 'ProjectOrderOptionEnabled').isActive;

        if (projectOrderOptionEnabled) {
            const poTemplate = languageFile["CONTRACT.WF.COMPENSATION.FIELD.PROJECT_ORDER"];
    
            const po = poTemplate
                .replace("{PROJECT_ORDER}", (workflowsQA['72'] || {}).notificationName);

            fields.ProjectOrder = { visible: true, label: po, required: false };
        }
    }

    var clauses = placeholdersQA.ClausesPM.values
                        .filter(item => item.isActive === true);

    fields.Type.clauses = clauses;

    // fields.Subject = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.SUBJECT"], required: true };
    // fields.Type =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.TYPE"], required: true };
    // fields.Description =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: false };
    // fields.TaskOrder = { visible: !!workflowsQA['38'], label: workflowsQA['38']?.notificationName, required: false };
    // fields.ProjectOrder =  { visible: !!workflowsQA['72'], label: workflowsQA['72']?.notificationName, required: false };

    // fields.Amount = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.AMOUNT"], required: false };
    // fields.EffectContractPrice =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DETAILS"], required: false };
    // fields.Days = { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DAYS"], required: false };
    // fields.EffectContractCompletion =  { visible: true, label: languageFile["GENERAL.FORMS.FIELD.DEFECTS"], required: false };

    return fields;
}

class AssessmentRouter extends React.Component {
    constructor(props) {
        super(props);
        this.documentType = 'DocumentAssessmentPM';

        this.replyingParty = props.workflowItem.replyingParty;

        this.notificationName = props.workflowItem.notificationName;
        this.abbreviation = props.workflowItem.abbreviation;
    }

    shouldComponentUpdate() {
        return false;
    }
    render() {
        const { workflowItem } = this.props;
        return (
            <Routes caseSensitive>
                <Route path={workflowItem.paths.basePath} exact element={<Navigate replace to={workflowItem.paths.defaultPath} />} />
                <Route
                    path={workflowItem.config.paths.list}
                    exact
                    element={<AssessmentList
                        {...this.props}
                        editingProperties={this.editingProperties}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                    />}

                />
                <Route
                    path={workflowItem.config.paths.create}
                    exact
                    element={
                        workflowItem.userFilters.mainNotice.createAllowed ? (
                            <AssessmentCreate
                                {...this.props}
                                mode={this.props.mode}
                                editingProperties={this.editingProperties}
                                title={this.notificationName}
                            />) : (
                            <Navigate replace to={workflowItem.paths.defaultPath} />
                        )
                    }
                />
                <Route
                    path={'/:notificationid/*'}
                    element={<AssessmentDetail
                        {...this.props}
                        mode={this.props.mode}
                        editingProperties={this.editingProperties}
                        title={this.notificationName}
                        abbreviation={this.abbreviation}
                        documentType={this.documentType}
                        notifyUserFilter={workflowItem.notifyUserFilter}
                    />}
                />
            </Routes>
        );
    }
};




export default (AssessmentRouter);